<template>
  <div class="excellent-capabilities-call-test">
    <common-bg-plate class="base-info">
      <detail-table title="基础信息" :table-col="tableCol" :list="params"> </detail-table>
    </common-bg-plate>
    <common-bg-plate class="call-section">
      <detail-section title="接口调用" class="test-foundation">
        <div class="foundation-content">
          <el-tabs v-model="activeName" style="width:100%" @tab-click="handleClick">
            <el-tab-pane
              v-for="(item, index) in encryptsvrs"
              :key="index"
              :label="item.title"
              :name="item.name"
            >
              <component
                :is="item.name"
                :ref="item.name"
                :data-obj="item"
                :name="item.name"
              ></component>
            </el-tab-pane>
          </el-tabs>
        </div>
      </detail-section>
    </common-bg-plate>
  </div>
</template>

<script>
import mpc from './components/mpc'
import cr from './components/cr'
import abe from './components/abe'

import serverNameImg from '@/assets/images/tableIcon/server-name.png'
import serverIpImg from '@/assets/images/tableIcon/server-ip.png'
import serverTimeImg from '@/assets/images/tableIcon/time.png'
export default {
  name: 'CallTest',
  components: {
    mpc,
    cr,
    abe
  },
  data() {
    return {
      tableCol: [
        { label: '服务器名称', icon: serverNameImg, value: 'servername' },
        { label: '当前服务器IP', icon: serverIpImg, value: 'ip' },
        {
          label: '创建时间',
          icon: serverTimeImg,
          value: 'createAt',
          formatter: (data, value) => this.formatTime(data[value])
        }
      ],
      params: {},
      encryptsvrs: [],
      activeName: 'mpc',
      encryptsInfos: {
        '1': {
          title: '多方安全计算',
          name: 'mpc'
        },
        '2': {
          title: '密文检索',
          name: 'cr'
        },
        '3': {
          title: '属性加密',
          name: 'abe'
        }
      }
    }
  },
  created() {
    this.params = JSON.parse(this.$route.query.row)
    this.activeName = 'mpc'
    let self = this
    JSON.parse(this.params.encryptsvrs).map((item, index) => {
      let encItem = Object.assign({}, item, self.encryptsInfos[item.serverID])
      encItem.ip = self.params.ip
      self.encryptsvrs.push(encItem)
    })
  },
  methods: {
    handleClick(tab) {
      //this.$refs['mpc'].refresh()
    },
    formatTime(time) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', time)
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.excellent-capabilities-call-test {
  @include adaptation(
    (
      --excellent-capabilities-call-test-min-height: 248px,
      --excellent-capabilities-call-test-margin-bottom: 16px
    )
  );
  --excellent-capabilities-call-test-call-section-min-height: calc(
    var(--base-main-router-body-avaliable-height) -
      var(--excellent-capabilities-call-test-min-height) -
      var(--excellent-capabilities-call-test-margin-bottom)
  );
  .common-bg-plate.base-info {
    min-height: var(--excellent-capabilities-call-test-min-height);
    margin-bottom: var(--excellent-capabilities-call-test-margin-bottom);
  }

  .common-bg-plate.call-section {
    min-height: var(--excellent-capabilities-call-test-call-section-min-height);

    /deep/ .content {
      padding-top: 0;
    }

    .el-tabs.el-tabs--top /deep/ {
      .el-tabs__header {
        margin: 0;
      }

      .el-tabs__content {
        padding: 0;
      }
    }
  }
}
</style>
